import { Component } from '@angular/core';

@Component({
    selector: 'app-social-facebook',
    templateUrl: './social-facebook.component.html',
    standalone: false
})
export class SocialFacebookComponent {
}
